import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installGlobalErrorHandlers } from './lib/errorReporter'

// Capture les erreurs JS hors-React (event handlers natifs, async, pre-mount).
// React ErrorBoundary couvre uniquement les render errors synchrones — sans ça,
// ~40% des crashes prod resteraient invisibles. Doit être appelé AVANT le
// premier render React. Cf. issue #38.
installGlobalErrorHandlers()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
